import { render, staticRenderFns } from "./globalBonusPool.vue?vue&type=template&id=b6a2c80e"
import script from "./globalBonusPool.vue?vue&type=script&lang=js"
export * from "./globalBonusPool.vue?vue&type=script&lang=js"
import style0 from "./globalBonusPool.vue?vue&type=style&index=0&id=b6a2c80e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports